import { inputCls, labelCls, FieldError, CheckRow } from "./ui";

const AGES = [9, 10, 11, 12, 13, 14, 15, 16, 17];

export function validateParticipant(form) {
  const e = {};
  if (!form.first_name.trim()) e.first_name = "Required";
  if (!form.last_name.trim()) e.last_name = "Required";
  if (!form.age) e.age = "Select your athlete's age";
  if (!form.guardian_name.trim()) e.guardian_name = "Parent / legal guardian full name is required";
  if (!form.email || !/.+@.+\..+/.test(form.email)) e.email = "Valid email required";
  if (!form.phone.trim()) e.phone = "Required";
  if (!form.emergency_name.trim()) e.emergency_name = "Required";
  if (!form.emergency_phone.trim()) e.emergency_phone = "Required";
  if (!form.accuracy_ack) e.accuracy_ack = "Please confirm the information is accurate";
  return e;
}

function Input({ k, form, set, errors, placeholder, type = "text", className = "" }) {
  return (
    <div className={className}>
      <input data-testid={`reg-${k.replace(/_/g, "-")}`} type={type} value={form[k]} onChange={(e) => set(k, e.target.value)} placeholder={placeholder}
        className={`${inputCls} ${errors[k] ? "border-red-400/60" : ""}`} />
      <FieldError msg={errors[k]} />
    </div>
  );
}

export default function StepParticipant({ form, set, errors, lockAge }) {
  const p = { form, set, errors };
  return (
    <div className="mt-6 space-y-6">
      <div>
        <p className={labelCls}>Participant (athlete)</p>
        <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Input k="first_name" placeholder="Athlete Legal First Name *" {...p} />
          <Input k="last_name" placeholder="Athlete Legal Last Name *" {...p} />
          <div>
            <label className={labelCls}>Age *</label>
            {lockAge ? (
              <p data-testid="reg-age-locked" className={`${inputCls} mt-2`}>{form.age} years old</p>
            ) : (
              <select data-testid="reg-age" value={form.age} onChange={(e) => set("age", e.target.value)} className={`${inputCls} mt-2 bg-[#0B0F19] ${errors.age ? "border-red-400/60" : ""}`}>
                <option value="">Select age</option>
                {AGES.map((a) => <option key={a} value={a}>{a} years old</option>)}
              </select>
            )}
            <FieldError msg={errors.age} />
          </div>
        </div>
      </div>
      <div>
        <p className={labelCls}>Parent / Legal Guardian</p>
        <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Input k="guardian_name" placeholder="Parent / Legal Guardian Full Legal Name *" className="sm:col-span-2" {...p} />
          <Input k="email" type="email" placeholder="Email *" {...p} />
          <Input k="phone" placeholder="Phone *" {...p} />
        </div>
      </div>
      <div>
        <p className={labelCls}>Emergency & Medical</p>
        <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Input k="emergency_name" placeholder="Emergency Contact Name *" {...p} />
          <Input k="emergency_phone" placeholder="Emergency Contact Phone *" {...p} />
          <Input k="med_conditions" placeholder="Medical conditions (or None)" {...p} />
          <Input k="med_allergies" placeholder="Allergies (or None)" {...p} />
          <Input k="med_medications" placeholder="Medications (or None)" {...p} />
          <Input k="med_injuries" placeholder="Injuries / restrictions (or None)" {...p} />
          <textarea data-testid="reg-med-other" value={form.med_other} onChange={(e) => set("med_other", e.target.value)} placeholder="Anything else we should know for safe participation (optional)" rows={2} className={`${inputCls} sm:col-span-2 resize-none`} />
        </div>
      </div>
      <CheckRow testid="reg-accuracy" checked={form.accuracy_ack} onChange={(v) => set("accuracy_ack", v)} error={errors.accuracy_ack}>
        The information provided is accurate, and I will notify Rep Lab of any relevant changes.
      </CheckRow>
    </div>
  );
}
